import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { TermsOfServiceContent } from '@/features/auth/components/TermsOfServiceContent';

type TermsOfServiceDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * Scrollable Terms of Service modal for registration and other auth flows.
 */
export function TermsOfServiceDialog({
  open,
  onOpenChange,
}: TermsOfServiceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[85vh] max-w-3xl overflow-y-auto bg-card text-foreground"
        aria-describedby="terms-of-service-description"
      >
        <DialogHeader>
          <DialogTitle className="text-foreground">Terms of Service</DialogTitle>
          <DialogDescription
            id="terms-of-service-description"
            className="text-muted-foreground"
          >
            Stevenson Systems, Inc. — Version 1.3, effective August 22, 2026.
          </DialogDescription>
        </DialogHeader>
        <TermsOfServiceContent />
      </DialogContent>
    </Dialog>
  );
}
